import { Alert, HeaderSecondary, HeaderBody } from "@fedsim/components"
import { ErrorBoundary, } from "react-error-boundary"
import { makeStyles, } from "@mui/styles"
import { Spacer, GameButton, Link, ButtonGroup, Container, CssBaseline, TextareaAutosize, } from "@fedsim/components"

import { trackEv, Categories, Actions } from 'analytics'
import useSaveGame from "hooks/useSaveGame"

export const useStyle = makeStyles(() => ({
  root: {
    fontFamily: "sans-serif",
    display: "flex",
    flexDirection: "column",
    maxWidth: "none !important",
  },
}))

const FallbackComponentWithLayout = ({ componentStack, error, }) => {
  const classes = useStyle()

  return (
    <>
      <CssBaseline />
      <Container className={classes.root} disableGutters component="section">
        <FallbackComponent error={error} x componentStack={componentStack} />
      </Container>
    </>
  )
}

const FallbackComponent = ({ componentStack, error, }) => {
  const { onDownload } = useSaveGame()
  const downloadHandler = () => {
    trackEv(Categories.Saves, Actions.Download)

    onDownload()
  }
  const onClear = () => {
    localStorage.clear();
    window.location.reload();
  }

  return (
    <>
      <Alert severity="error">
        <HeaderSecondary>FSX has encountered an error</HeaderSecondary>
        <Spacer />
        <HeaderBody>
          We've encountered an error.
          Try reloading the homepage.
          If the issue persists, back up your game using the button below, reset your cache, and reload.
          If the problem persists, share your save game in the <Link color="inherit" href="https://discord.gg/f7QacdXX">testing Discord with tests to reproduce</Link>.
        </HeaderBody>
      </Alert>
      <Spacer />
      <ButtonGroup>
        <GameButton color="success" variant="contained" size="small" onClick={downloadHandler}>Download and backup save</GameButton>
        <GameButton color="error" variant="contained" size="small" onClick={onClear}>Click here to reset your game ENTIRELY!</GameButton>
      </ButtonGroup>
      <Spacer />
      <TextareaAutosize style={{ width: "100%", }} defaultValue={error.toString() + componentStack} />
    </>
  )
}

export function InnerError({ children, }) {
  return <ErrorBoundary FallbackComponent={FallbackComponent}>{children}</ErrorBoundary>
}

export function Error({ children, }) {
  return <ErrorBoundary FallbackComponent={FallbackComponentWithLayout}>{children}</ErrorBoundary>
}

export default Error
